import React from 'react';
import { PlayerInfoProps } from '@screens/players/types/player.info.props';
import { InfoArea, InfoAreaTitle } from '@screens/players/player.details.tabs/player.info.styles';
import { StatsContainer } from '@screens/players/stats.container';
import { StatRow } from '@screens/players/stat.display';
import { formatStringDate } from '@domain/utils/format.utils';

export const AccountInfo = ({ info }: PlayerInfoProps) => {
  const account = info.detailAccount;
  if (!account) return null;

  return (
    <InfoArea>
      <InfoAreaTitle>Account</InfoAreaTitle>
      <StatsContainer outlined column expandHeight>
        <StatRow label='Registered at'>{formatStringDate(account.register)}</StatRow>
        <StatRow label='Last login'>{formatStringDate(account.lastLogin)}</StatRow>
        <StatRow label='Login count'>{account.loginCount}</StatRow>
        <StatRow label='Last payment'>{formatStringDate(account.lastPayment)}</StatRow>
      </StatsContainer>
    </InfoArea>
  );
};
